// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error_wrapper___HdWF","image":"Error_image__YdQ6F","title":"Error_title__3fFuX","subtitle":"Error_subtitle__3Knu-","button":"Error_button__31qVy"};